export default __webpack_public_path__ + "static/illustration-action.url-761784ec0350c2d076028b0dc0ec0001.svg";